module.exports = __webpack_public_path__ + "static/img/logo1.b0230d95.png";